// extracted by mini-css-extract-plugin
export default {"root":"Jv7BJdsulJ","root_active":"IKTfpM4QO8"};